var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-container',{attrs:{"navs":_vm.navs,"isLoading":_vm.isLoading,"isError":_vm.isError},scopedSlots:_vm._u([{key:"rendered",fn:function(){return [_c('edit-project',{key:_vm.$route.params.id,attrs:{"data":_vm.data}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }